// extracted by mini-css-extract-plugin
export var collapser = "StickyNav-module--collapser--2D2Ml";
export var list = "StickyNav-module--list--3Fnz1";
export var wrap = "StickyNav-module--wrap--gQ6PD";
export var top = "StickyNav-module--top--2hYtp";
export var stick = "StickyNav-module--stick--2YGyb";
export var current = "StickyNav-module--current--2_mZF";
export var headingButton = "StickyNav-module--heading-button--19mjW";
export var headingButtonOpen = "StickyNav-module--heading-button-open--3lw6H";
export var headingButtonClosed = "StickyNav-module--heading-button-closed--1UTi6";